<template>
	<div class='hello-view view'>
		<section class='card'>
			<img
				height='200'
				width='200'
				class='card__avatar'
				src='../assets/me.jpg'
				alt='a picture of me' />
			<article class='card__text'>
				<p>I'm Stela and I'm a Frontend Developer.</p>
				<p></p>
				<p>Currently I'm based in <strong>Berlin</strong></p>
			</article>
		</section>
		<router-link
			class='link card__link'
			to='/projects'>projects →</router-link>
	</div>
</template>

<script>
export default {
	name: 'Hello',
}
</script>

<style lang='less' scoped>

.hello-view {
	display: flex;
	flex-direction: column;
}

.card {
	display: flex;
	align-items: center;
}

.card__text {
	margin: 0 0 0 50px;
}

.card__avatar {
	border-radius: 50%;
}

.card__link {
	text-align: right;
}

@media screen and (max-width: 900px) {

	.card {
		flex-direction: column;
	}

	.card__text {
		margin: 40px 0;
	}
}

@media screen and (max-width: 500px) {

	.card {
		margin: 50px 0 0 0;
	}
}

</style>
